﻿import axios from 'axios';
import {updateCounter} from '../../Header/Scripts/index.js';

export default class ShoppingCart {
    mainSelector = 'main';
    shoppingCartSelector = '[data-js-shopping-cart]';
    shoppingCartItemSelector = '[data-js-shopping-cart-item]';
    shoppingCartItemSummarySelector = '[data-js-cart-summary]';
    shoppingCartItemHeaderSelector = '[data-js-cart-header]';
    emptySelector = '[data-js-cart-empty]';
    removeSelector = '[data-js-remove-from-cart]';
    decreaseSelector = '[data-js-cart-decrease]';
    increaseSelector = '[data-js-cart-increase]';
    summary = '[data-js-shopping-cart-sum]';
    quantity = '[data-js-cart-quantity]';

    disabledClass = 'disabled';
    hiddenClass = 'hidden';

    constructor() {
        this.setupComponent();
    }

    setupComponent() {
        const elements = getElementList(document, this.shoppingCartSelector);
      
        elements.forEach(element => {
            this.setupShoppingCart(element);
        });
    }

    setupShoppingCart(element) {
        this.handleEmptyCart();

        const shippingCartItems = getElementList(element, this.shoppingCartItemSelector);
        const summaryElement = getElementList(element, this.summary)[0];

        shippingCartItems.forEach(cartItem => {
            this.setupEvents(cartItem, summaryElement);
        });
    }

    setupEvents(cartItem, summaryElement) {
        const removeButtons = cartItem.querySelectorAll(this.removeSelector);
        const decreaseButtons = cartItem.querySelectorAll(this.decreaseSelector);
        const increaseButtons = cartItem.querySelectorAll(this.increaseSelector);
        const quantityFields = cartItem.querySelectorAll(this.quantity);


        if (quantityFields) {
            quantityFields.forEach(field => {

                if (removeButtons) {
                    removeButtons.forEach(button => {
                        button.addEventListener('click', (event) => {

                            event.stopPropagation();
                            event.preventDefault();

                            this.removeItem(button, cartItem, summaryElement);
                        })
                        this.handleButtonState(cartItem, button, field.value);
                    })
                }

                if (decreaseButtons) {
                    decreaseButtons.forEach(button => {
                        button.addEventListener('click', (event) => {
                            event.stopPropagation();
                            event.preventDefault();

                            const currentQuantity = parseInt(field.value);

                            if (currentQuantity > 1) {
                                this.updateItem(button, field, summaryElement, currentQuantity - 1, cartItem);
                            }
                        })
                        this.handleButtonState(cartItem, button, field.value);
                    })
                }

                if (increaseButtons) {
                    increaseButtons.forEach(button => {
                        button.addEventListener('click', (event) => {
                            event.stopPropagation();
                            event.preventDefault();

                            const currentQuantity = parseInt(field.value);

                            if (currentQuantity <= 15) {
                                this.updateItem(button, field, summaryElement, currentQuantity + 1, cartItem);
                            }
                        })
                        this.handleButtonState(cartItem, button, field.value);
                    })
                } 
            })
          
        }
    }

    removeItem(button, cartItem, summaryElement) {
        const href = button.getAttribute('href');
        const url = href.substring(0, href.indexOf('?'));
        const id = getQueryParam(href, 'id');

        axios.get(url, {
            params: {
                id: id,
                output: 'json',
                cmd: 'rmv'
            }
        })
            .then(response => {
                cartItem.parentNode.removeChild(cartItem);
                updateCounter(response.data.totalCount);
                summaryElement.textContent = response.data.summary + ' kr (ex. moms)';
                this.handleEmptyCart();
            });
    }

    updateItem(button, quantityField, summaryElement, qnt, cartItem) {
        const href = button.getAttribute('href');
        const url = href.substring(0, href.indexOf('?'));
        const id = getQueryParam(href, 'id');

        axios.get(url, {
            params: {
                id: id,
                output: 'json',
                cmd: 'upd',
                qnt: qnt
            }
        })
            .then(response => {

            updateCounter(response.data.totalCount); 
            quantityField.value = qnt;
            summaryElement.textContent = response.data.summary + ' kr (ex. moms)';

            this.handleButtonState(cartItem, button, quantityField.value, qnt);
        });
    }


    handleButtonState(cartItem, button, currentQuantity, qnt) {
        const decreaseButton = cartItem.querySelector(this.decreaseSelector);
        const increaseButton = cartItem.querySelector(this.increaseSelector);     

        if (currentQuantity > 14 && !increaseButton.classList.contains(this.disabledClass)) {
            increaseButton.classList.add(this.disabledClass);
            increaseButton.setAttribute('tabindex', '-1');
        }

        if (currentQuantity > 1 && currentQuantity < 15) {
          
            if (increaseButton && increaseButton.classList.contains(this.disabledClass)) {
                increaseButton.classList.remove(this.disabledClass);
                increaseButton.setAttribute('tabindex', '0');
            }

            if (decreaseButton && decreaseButton.classList.contains(this.disabledClass)) {
                decreaseButton.classList.remove(this.disabledClass);
                decreaseButton.setAttribute('tabindex', '0');

            } else {
                return;
            }
        }

        if (currentQuantity < 2 || currentQuantity === 1) {
            decreaseButton.classList.add(this.disabledClass);
            decreaseButton.setAttribute('tabindex', '-1');
        }
    }

    handleEmptyCart() {
        const cartItem = document.querySelector(this.shoppingCartItemSelector);
        const cartSummary = document.querySelector(this.shoppingCartItemSummarySelector);
        const cartHeader = document.querySelector(this.shoppingCartItemHeaderSelector);
        const cartEmpty = document.querySelector(this.emptySelector);

        if (!cartItem) {
            cartSummary.parentNode.removeChild(cartSummary);
            cartHeader.parentNode.removeChild(cartHeader);
            cartEmpty.classList.remove(this.hiddenClass);
        } else {
            cartEmpty.classList.add(this.hiddenClass);
            cartEmpty.focus();
        }
    }
}


function getElementList(parent, query) {
    const elements = parent.querySelectorAll(query);
    return Array.from(elements);
}

function getQueryParam(query, name) {
    var q = query.match(new RegExp('[?&]' + name + '=([^&#]*)'));
    return q && q[1];
}